import useSite from '~/client/hooks/useSite';
import NextLink from '~/client/shared/NextLink';
import ProviderGameImage from './styles/ProviderGameImage';
import ProviderGamesContainer from './styles/ProviderGamesContainer';
import getGameHref from './utils/getGameHref';
import getGamesList from './utils/getGamesList';
import type { CasinoProviderGameFragment } from '../../../graphql/ProvidersListQuery.generated';

type Props = {
  games?: CasinoProviderGameFragment[];
  sendToGtm: (action?: string) => void;
};

const PROVIDER_CARD_HEIGHT: Record<string, number> = {
  '3': 88,
  '2': 148,
  '1': 300,
};

const useProviderGames = ({ games, sendToGtm }: Props) => {
  const { isSportsbet } = useSite();
  const { cols, count } = getGamesList({ gameCount: games?.length ?? 1 });
  const providerItems = games?.slice(0, count).map((game) => (
    <NextLink
      prefetch={false}
      href={getGameHref(isSportsbet, game?.href)}
      key={game?.id}
      onClick={() => sendToGtm('provider_game_card')}
    >
      <ProviderGameImage
        height={PROVIDER_CARD_HEIGHT[cols]}
        src={game?.thumbUrl}
      />
    </NextLink>
  ));

  return { providerItems, cols };
};

const ProviderGames: FC<Props> = ({ games, sendToGtm }) => {
  const { providerItems, cols } = useProviderGames({ games, sendToGtm });
  return (
    <ProviderGamesContainer cols={cols}>{providerItems}</ProviderGamesContainer>
  );
};

export default ProviderGames;
